import React from 'react';

const Icon = ({name, width, height, className = 'slx-button__icon'}) => (
	<span className={className}>
		<span data-slx-type="svg">
			<canvas width={width} height={height}/>
			<svg viewBox={`0 0 ${width} ${height}`} focusable="false" aria-hidden="true">
				<use xlinkHref={`#${name}`}/>
			</svg>
		</span>
	</span>
);

export default Icon;
